export const utils = {
    Browser: (() => {
        const UA = navigator.userAgent.toLowerCase();        
        const iosVer = UA.match(/cpu iphone os (.*?) like mac os/);
        return {//移动终端浏览器版本信息
            mobile: 'ontouchstart' in window || UA.indexOf('touch') > -1 || UA.indexOf('mobile') > -1,
            webkit: UA.indexOf('applewebkit') > -1, //WebKit
            safari: UA.indexOf('safari') > -1 && UA.indexOf('edgios') == -1 && UA.indexOf('fxios') == -1 && UA.indexOf('crios') == -1 && UA.indexOf('fingerbrowser') == -1 && UA.indexOf('chrome') == -1 && UA.indexOf('mqqbrowser') == -1 , //Safari
            ie: !!window.ActiveXObject || 'ActiveXObject' in window, //IE
            ios: !!UA.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/i), //IOS
            mac: UA.indexOf('mac os x') > -1, //MAC OS
            android: UA.indexOf('android') > -1 || UA.indexOf('adr') > -1, //Android
            iphone: UA.indexOf('iphone') > -1, //iPhone
            ipad: UA.indexOf('ipad') > -1, //iPad
            wechat: UA.indexOf('micromessenger') > -1, //WeChart
            pcWechart: UA.indexOf('windowswechat') > -1, //PC WeChart
            qq: UA.match(/ qq\//g) == ' qq/', //QQ
            weibo: UA.indexOf('weibo') > -1, //WeiBo
            baidu: UA.indexOf('baidu') > -1, //百度
            ios_ver:(iosVer && iosVer.length > 0)?parseFloat(iosVer[1].replace('_','.')):0
        };
    })()
}
